cb.define([], function() {
  var pc_goodsproductskuprolist_filterVM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function(viewmodel) {
      viewmodel.on('beforeSearch', (args) => {
        let prodcutTags = args.commonVOs.filter(v => v.itemName === "prodcutTag")
        if (prodcutTags.length && prodcutTags[0].value1.length > 1) {
          args.isDistinct = true;
        }
      });
      viewmodel.on('afterInit', (args) => {
        //组织附默认值
        let orgId = cb.rest.AppContext.user.orgId;
        let userOrgs = cb.rest.AppContext.user.userOrgs;
        let defaultValue = { id: orgId };
        let currentOrg = userOrgs && userOrgs.find(function(item) {
          return item.org === orgId;
        });
        if (currentOrg) {
          defaultValue.code = currentOrg.org_code;
          defaultValue.name = currentOrg.org_name;
        }
        const userType = cb.rest.AppContext.user.userType
        //只能参照到当前用户有权限的组织
        if ((userType === 0 || userType === 1) && viewmodel.get("productId.orgId")) {
          viewmodel.get("productId.orgId").getFromModel().setValue([defaultValue]);
        }
      });
    }
  }
  try {
    module.exports = pc_goodsproductskuprolist_filterVM_Extend;
  } catch (error) {}
  return pc_goodsproductskuprolist_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/pc_goodsproductskuprolist_filterVM.Extend.js